import { render, staticRenderFns } from "./statistic.vue?vue&type=template&id=de0e194a&scoped=true&"
import script from "./statistic.vue?vue&type=script&lang=js&"
export * from "./statistic.vue?vue&type=script&lang=js&"
import style0 from "./statistic.vue?vue&type=style&index=0&id=de0e194a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0e194a",
  null
  
)

export default component.exports